import Header from '../components/header/Header';
import Footer from '../components/home/Footer';
import Section0 from '../components/home/Section0';
import Section1 from '../components/home/Section1';
import Section2 from '../components/home/Section2';
import Section3 from '../components/home/Section3';
import Section4 from '../components/home/Section4';
import Section5 from '../components/home/Section5';
import Section6 from '../components/home/Section6';
import Slider from '../components/home/Slider';



const Home = () => {
    return (
        <div>
            <h1 className='hidden'>Genesis Trade Lojistik, lojistik sektöründe güvenilir bir çözüm ortağı olarak, size hızlı, etkili ve yenilikçi hizmetler sunar. Çünkü bizim için her yük, sadece bir taşınma değil; iş ortaklarımızın başarısına katkı sağlayan bir adımdır.</h1>

            {/* <Header /> */}

            <Slider />




            <Section0 />





            <Section1 />



            <Section2 />


            <Section3 />



            {/* <Section4 /> */}


            <Section5 />


            <Section6 />







        </div>
    )
}

export default Home